import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-call-offer',
  templateUrl: './alert-call-offer.component.html',
  styleUrls: ['./alert-call-offer.component.css']
})
export class AlertCallOfferComponent {

}
